import { Promise } from "bluebird";
import { TransportInterface } from "./TransportInterface";
import { ConsoleTransport } from "./Transports/ConsoleTransport";
import { RollbarTransport } from "./Transports/RollbarTransport";
import { NullTransport } from "./Transports/NullTransport";

class Logger {

  constructor(private transports: TransportInterface[]) {

  }

  public log(message: string , shouldLogToTransport?: boolean, data?: any): any {
    return Promise.map(this.transports, Transport => Transport.log(message, shouldLogToTransport, data));
  }

  public warn(message: string): any {
    return Promise.map(this.transports, Transport => Transport.warn(message));
  }

  public debug(data: any, prefix: string = ""): any {
    return Promise.map(this.transports, Transport => Transport.debug(data, prefix));
  }

  public logError(err: any, level?: string): any {
    return Promise.map(this.transports, Transport => Transport.logError(err, level));
  }
}

export default new Logger([
  new ConsoleTransport(),
  new RollbarTransport(),
  new NullTransport()
]);
